/* eslint-disable */
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import * as portalApis from '../../services/portalApis';
import * as platformApis from '../../services/platformApis';
import {
  ADD_SCHOOL,
  GET_PROGRAMS,
  GET_FIELD_OF_STUDY,
  GET_CURRENCY,
  GET_QUALIFICATION,
  GET_STUDY_LEVEL,
  GET_SCHOOL_FOS,
  ADD_SCHOOL_PROGRAM,
  DELETE_SCHOOL_PROGRAM,
  ADD_SCHOOL_FOS,
  DELETE_SCHOOL_FOS
} from "../actions";
import { addSchoolError, addSchoolFosError, addSchoolFosSuccess, addSchoolProgramError, addSchoolProgramSuccess, addSchoolSuccess, deleteSchoolFosError, deleteSchoolFosSuccess, deleteSchoolProgramError, deleteSchoolProgramSuccess, getCurrencyError, getCurrencySuccess, getFosError, getFosSuccess, getProgramsError, getProgramsSuccess, getQualificationError, getQualificationSuccess, getSchoolFOSError, getSchoolFOSSuccess, getStudyLevelError, getStudyLevelSuccess } from "./actions";

function* addSchool({ payload }) {
  try {
    const { data, props } = payload;
    let response = yield call(portalApis.post, data);

    if (response.meta.code === 200) {
      yield put(addSchoolSuccess(response));
    } else if (response.meta.code === 400) {
      var responseToSring = response.Data.map(function (item) {
        return Object.values(item).toString();
      });
      yield put(addSchoolError(responseToSring.toString()));
    } else {
      yield put(addSchoolError(response.meta.Message));
    }
  } catch (error) {
    yield put(addSchoolError(error.message));
  }
}

function* getProgram({ payload }) {
  try {
    const { data, props } = payload;
    const dataFinal = {
      url: "schools/getSchoolPrograms/"
    }
    let response = yield call(platformApis.get, dataFinal);

    if (response.meta.code === 200) {
      yield put(getProgramsSuccess(response));
    } else if (response.meta.code === 400) {
      var responseToSring = response.Data.map(function (item) {
        return Object.values(item).toString();
      });
      yield put(getProgramsError(responseToSring.toString()));
    } else {
      yield put(getProgramsError(response.meta.Message));
    }
  } catch (error) {
    yield put(getProgramsError(error.message));
  }
}
function* getFieldOfStudy({ payload }) {
  try {
    const { data, props } = payload;
    const dataFinal = {
      url: "schools/fieldOfStudy"
    }
    let response = yield call(platformApis.get, dataFinal);

    if (response.meta.code === 200) {
      yield put(getFosSuccess(response));
    } else if (response.meta.code === 400) {
      var responseToSring = response.Data.map(function (item) {
        return Object.values(item).toString();
      });
      yield put(getFosError(responseToSring.toString()));
    } else {
      yield put(getFosError(response.meta.Message));
    }
  } catch (error) {
    yield put(getFosError(error.message));
  }
}
function* getCurrency({ payload }) {
  try {
    const { data, props } = payload;
    const dataFinal = {
      url: "schools/getCurrency"
    }
    let response = yield call(platformApis.get, dataFinal);

    if (response.meta.code === 200) {
      yield put(getCurrencySuccess(response));
    } else if (response.meta.code === 400) {
      var responseToSring = response.Data.map(function (item) {
        return Object.values(item).toString();
      });
      yield put(getCurrencyError(responseToSring.toString()));
    } else {
      yield put(getCurrencyError(response.meta.Message));
    }
  } catch (error) {
    yield put(getCurrencyError(error.message));
  }
}
function* getQualification({ payload }) {
  try {
    const { data, props } = payload;
    const dataFinal = {
      url: "schools/getQualification"
    }
    let response = yield call(platformApis.get, dataFinal);

    if (response.meta.code === 200) {
      yield put(getQualificationSuccess(response));
    } else if (response.meta.code === 400) {
      var responseToSring = response.Data.map(function (item) {
        return Object.values(item).toString();
      });
      yield put(getQualificationError(responseToSring.toString()));
    } else {
      yield put(getQualificationError(response.meta.Message));
    }
  } catch (error) {
    yield put(getQualificationError(error.message));
  }
}
function* getStudyLevel({ payload }) {
  try {
    const { data, props } = payload;
    const dataFinal = {
      url: "schools/getStudyLevel"
    }
    let response = yield call(platformApis.get, dataFinal);

    if (response.meta.code === 200) {
      yield put(getStudyLevelSuccess(response));
    } else if (response.meta.code === 400) {
      var responseToSring = response.Data.map(function (item) {
        return Object.values(item).toString();
      });
      yield put(getStudyLevelError(responseToSring.toString()));
    } else {
      yield put(getStudyLevelError(response.meta.Message));
    }
  } catch (error) {
    yield put(getStudyLevelError(error.message));
  }
}
function* getSchoolFOS({ payload }) {
  try {
    const { data, props } = payload;
    const dataFinal = {
      url: "schools/schoolFosList"
    }
    let response = yield call(platformApis.get, dataFinal);

    if (response.meta.code === 200) {
      yield put(getSchoolFOSSuccess(response));
    } else if (response.meta.code === 400) {
      var responseToSring = response.Data.map(function (item) {
        return Object.values(item).toString();
      });
      yield put(getSchoolFOSError(responseToSring.toString()));
    } else {
      yield put(getSchoolFOSError(response.meta.Message));
    }
  } catch (error) {
    yield put(getSchoolFOSError(error.message));
  }
}
function* addSchoolProgram({ payload }) {
  try {
    const { data, props } = payload;
    const dataFinal = {
      url: "schools/addSchoolProgram",
      data
    }
    let response = yield call(platformApis.post, dataFinal);
    if (response.meta.code === 200) {
      props.history.push('./list')
      yield put(addSchoolProgramSuccess(response));
    } else if (response.meta.code === 400) {
      var responseToSring = response.Data.map(function (item) {
        return Object.values(item).toString();
      });
      yield put(addSchoolProgramError(responseToSring.toString()));
    } else {
      yield put(addSchoolProgramError(response.meta.Message));
    }
  } catch (error) {
    yield put(addSchoolProgramError(error.message));
  }
}
function* deleteSchoolProgram({ payload }) {
  try {
    const { data, props } = payload;
    const dataFinal = {
      url: "schools/deleteSchoolProgram",
      data
    }
    let response = yield call(platformApis.post, dataFinal);
    if (response.meta.code === 200) {
      props.history.push('./list')
      yield put(deleteSchoolProgramSuccess(response));
    } else if (response.meta.code === 400) {
      var responseToSring = response.Data.map(function (item) {
        return Object.values(item).toString();
      });
      yield put(deleteSchoolProgramError(responseToSring.toString()));
    } else {
      yield put(deleteSchoolProgramError(response.meta.Message));
    }
  } catch (error) {
    yield put(deleteSchoolProgramError(error.message));
  }
}

function* addSchoolFos({ payload }) {
  try {
    const { data, props } = payload;
    const dataFinal = {
      url: "schools/addfieldOfStudy",
      data
    }
    let response = yield call(platformApis.post, dataFinal);
    if (response.meta.code === 200) {
      props.history.push('./list')
      yield put(addSchoolFosSuccess(response));
    } else if (response.meta.code === 400) {
      var responseToSring = response.Data.map(function (item) {
        return Object.values(item).toString();
      });
      yield put(addSchoolFosError(responseToSring.toString()));
    } else {
      yield put(addSchoolFosError(response.meta.Message));
    }
  } catch (error) {
    yield put(addSchoolFosError(error.message));
  }
}
function* deleteSchoolFos({ payload }) {
  try {
    const { data, props } = payload;
    const dataFinal = {
      url: "schools/deleteFos",
      data
    }
    let response = yield call(platformApis.post, dataFinal);
    if (response.meta.code === 200) {
      yield put(deleteSchoolFosSuccess(response));
    } else if (response.meta.code === 400) {
      var responseToSring = response.Data.map(function (item) {
        return Object.values(item).toString();
      });
      yield put(deleteSchoolFosError(responseToSring.toString()));
    } else {
      yield put(deleteSchoolFosError(response.meta.Message));
    }
  } catch (error) {
    yield put(deleteSchoolFosError(error.message));
  }
}
export function* watchAddSchool() {
  yield takeEvery(ADD_SCHOOL, addSchool);
}
export function* watchGetProgram() {
  yield takeEvery(GET_PROGRAMS, getProgram);
}
export function* watchGetFieldOfStudy() {
  yield takeEvery(GET_FIELD_OF_STUDY, getFieldOfStudy);
}
export function* watchGetCurrency() {
  yield takeEvery(GET_CURRENCY, getCurrency);
}
export function* watchGetQualification() {
  yield takeEvery(GET_QUALIFICATION, getQualification);
}
export function* watchGetStudyLevel() {
  yield takeEvery(GET_STUDY_LEVEL, getStudyLevel);
}
export function* watchGetSchoolFOS() {
  yield takeEvery(GET_SCHOOL_FOS, getSchoolFOS);
}
export function* watchAddSchoolProgram() {
  yield takeEvery(ADD_SCHOOL_PROGRAM, addSchoolProgram);
}
export function* watchDeleteSchoolProgram() {
  yield takeEvery(DELETE_SCHOOL_PROGRAM, deleteSchoolProgram);
}
export function* watchAddSchoolFos() {
  yield takeEvery(ADD_SCHOOL_FOS, addSchoolFos);
}
export function* watchDeleteSchoolFos() {
  yield takeEvery(DELETE_SCHOOL_FOS, deleteSchoolFos);
}

export default function* rootSaga() {
  yield all([
    fork(watchAddSchool),
    fork(watchGetProgram),
    fork(watchGetFieldOfStudy),
    fork(watchGetCurrency),
    fork(watchGetQualification),
    fork(watchGetStudyLevel),
    fork(watchGetSchoolFOS),
    fork(watchAddSchoolProgram),
    fork(watchDeleteSchoolProgram),
    fork(watchAddSchoolFos),
    fork(watchDeleteSchoolFos)
  ]);
}
